import { render } from "./Step1Component.vue?vue&type=template&id=20ca5fd0&scoped=true"
import script from "./Step1Component.vue?vue&type=script&lang=js"
export * from "./Step1Component.vue?vue&type=script&lang=js"

import "./Step1Component.vue?vue&type=style&index=0&id=20ca5fd0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ca5fd0"]])

export default __exports__